/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { BuilderSharedModule, JobDrawDetailsTabBusinessService } from '@gh/builder-shared';
import { CoreUiExtSplitPaneModule } from '@gh/core-ui-ext/split-pane';
import { CoreUiExtTreeModule } from '@gh/core-ui-ext/tree';

import { BuilderJobAdminRoutingModule } from './builder-job-admin-routing.module';
import {
  JeAddOrdersDialogComponent,
  JeCcOrderDetailsDialogComponent,
  JeDetailsCcItemComponentComponent,
  JeDetailsCcItemDetailsComponent,
  JeDetailsCcItemListComponent,
  JeDetailsCcListComponent,
  JeDetailsCcParentComponent,
  JeDetailsColorSelectionListComponent,
  JeDetailsComponentDetailsComponent,
  JeDetailsComponentListComponent,
  JeDetailsComponentsParentComponent,
  JeDetailsCuttingListComponent,
  JeDetailsOrderListComponent,
  JeDetailsTopListComponent,
  JeTopUsageDialogComponent,
  JobCoDetailsQuoteFilterDialogComponent,
  JobCsDetailsBusinessService,
  JobCsDetailsCcListComponent,
  JobCsDetailsComponent,
  JobCsDetailsHeadingListComponent,
  JobCsDetailsItemListComponent,
  JobCsDetailsSubheadingListComponent,
  JobCsDetailsTopFormComponent,
  JobEstimateDetailsBusinessService,
  JobEstimateDetailsComponent,
  JobListBusinessService,
  JobListComponent,
  JobOrderDetailsAttachmentDialogComponent,
  JobOrderDetailsBodyComponent,
  JobOrderDetailsBottomPanelComponent,
  JobOrderDetailsBusinessService,
  JobOrderDetailsDialogComponent,
  JobOrderDetailsListBusinessService,
  JobOrderDetailsTopFormComponent,
  JobOrderListBusinessService,
  JobOrderListComponent,
  JobQuickDetailsBusinessService,
  JobQuickDetailsComponent,
} from './jobs';
import {
  JobCoDetailsBottomPanelComponent,
} from './jobs/components/job-co-details/job-co-details-bottom-panel/job-co-details-bottom-panel.component';
import {
  JobCoDetailsElementListComponent,
} from './jobs/components/job-co-details/job-co-details-element-list/job-co-details-element-list.component';
import {
  JobCoDetailsTopFormComponent,
} from './jobs/components/job-co-details/job-co-details-top-form/job-co-details-top-form.component';
import { JobCoDetailsComponent } from './jobs/components/job-co-details/job-co-details.component';
import { JobCoListComponent } from './jobs/components/job-co-list/job-co-list.component';
import { JobCoTopFormComponent } from './jobs/components/job-co-list/job-co-top-form/job-co-top-form.component';
import {
  JobDetailsCommunicationListTabComponent,
} from './jobs/components/job-details-tab-container/job-details-communication-list-tab/job-details-communication-list-tab.component';
import {
  JobDetailsDatesTabComponent,
} from './jobs/components/job-details-tab-container/job-details-dates-tab/job-details-dates-tab.component';
import {
  JobDetailsEDocsManagementComponent,
} from './jobs/components/job-details-tab-container/job-details-edocs-tab/job-details-e-docs-management/job-details-e-docs-management.component';
import {
  JobDetailsEDocsOwnerSetFormComponent,
} from './jobs/components/job-details-tab-container/job-details-edocs-tab/job-details-e-docs-owner-set-form/job-details-e-docs-owner-set-form.component';
import {
  JobDetailsEDocsTabComponent,
} from './jobs/components/job-details-tab-container/job-details-edocs-tab/job-details-e-docs-tab.component';
import {
  JobDetailsGeneralTabComponent,
} from './jobs/components/job-details-tab-container/job-details-general-tab/job-details-general-tab.component';
import {
  JobDetailsInsuranceTabComponent,
} from './jobs/components/job-details-tab-container/job-details-insurance-tab/job-details-insurance-tab.component';
import {
  JobDetailsLetterListTabComponent,
} from './jobs/components/job-details-tab-container/job-details-letter-list-tab/job-details-letter-list-tab.component';
import {
  JobDetailsRfqTabComponent,
} from './jobs/components/job-details-tab-container/job-details-rfq-tab/job-details-rfq-tab.component';
import {
  JobDetailsSharedDocListTabComponent,
} from './jobs/components/job-details-tab-container/job-details-shared-doc-list-tab/job-details-shared-doc-list-tab.component';
import {
  JobDetailsTabContainerComponent,
} from './jobs/components/job-details-tab-container/job-details-tab-container.component';
import {
  JobDetailToolbarComponent,
} from './jobs/components/job-details-tab-container/job-details-toolbar-component/job-details-toolbar.component';
import {
  JobDetailsVariationListTabComponent,
} from './jobs/components/job-details-tab-container/job-details-variation-list-tab/job-details-variation-list-tab.component';
import {
  JobDetailsWarrantyTaskDialogComponent,
} from './jobs/components/job-details-tab-container/job-details-warranty-task-details-dialog/job-details-warranty-task-details-dialog.component';
import {
  JobDetailsWarrantyTabComponent,
} from './jobs/components/job-details-tab-container/job-details-warranty-task-list-tab/job-details-warranty-task-list-tab.component';
import {
  SelectSupervisorDialogComponent,
} from './jobs/components/job-details-tab-container/select-supervisor-dialog/select-supervisor-dialog.component';
import {
  JobDppDetailsContainerComponent,
} from './jobs/components/job-dpp-details-container/job-dpp-details-container.component';
import {
  JobDppDetailsGeneralTabComponent,
} from './jobs/components/job-dpp-details-container/job-dpp-details-general-tab/job-dpp-details-general-tab.component';
import {
  JobFinancialsDrawListComponent,
} from './jobs/components/job-financials/job-financials-draw-list/job-financials-draw-list.component';
import {
  JobFinancialsExpenseListComponent,
} from './jobs/components/job-financials/job-financials-expense-list/job-financials-expense-list.component';
import {
  JobFinancialsTopFormComponent,
} from './jobs/components/job-financials/job-financials-top-form/job-financials-top-form.component';
import {
  JobFinancialsTradingAccountComponent,
} from './jobs/components/job-financials/job-financials-trading-account/job-financials-trading-account.component';
import { JobFinancialsComponent } from './jobs/components/job-financials/job-financials.component';
import { JobSpecDetailsComponent } from './jobs/components/job-spec-details/job-spec-details.component';
import {
  JobSpecParagraphFormComponent,
} from './jobs/components/job-spec-details/job-spec-paragraph-form/job-spec-paragraph-form.component';
import {
  JobSpecQuoteChangesFormComponent,
} from './jobs/components/job-spec-details/job-spec-quote-changes-form/job-spec-quote-changes-form.component';
import {
  JobSpecSectionFormComponent,
} from './jobs/components/job-spec-details/job-spec-section-form/job-spec-section-form.component';
import {
  JobSpecTopFormComponent,
} from './jobs/components/job-spec-details/job-spec-top-form/job-spec-top-form.component';
import { JobCoDetailsBusinessService } from './jobs/resources/job-co-details-business.service';
import { JobCoListBusinessService } from './jobs/resources/job-co-list-business.service';
import { JobDetailsTabBusinessService } from './jobs/resources/job-details-tab/job-details-tab-business.service';
import { JobDPPBusinessService } from './jobs/resources/job-dpp-business.service';
import { JobFinancialsBusinessService } from './jobs/resources/job-financials-business.service';
import { JobSpecBusinessService } from './jobs/resources/job-spec-business.service';
import {
  JobCsDetailsQcListComponent,
} from './jobs/components/job-cs-details/job-cs-details-qc-list/job-cs-details-qc-list.component';
import {
  JobDetailsReassignDialogComponent,
} from './jobs/components/job-details-tab-container/job-details-reassign-dialog/job-details-reassign-dialog.component';
import { JobCoJobListComponent } from './jobs/components/job-co-job-list/job-co-job-list.component';
import { JobCoJobListBusinessService } from './jobs/resources/job-co-job-list-business.service';
import { JobOrderDetailsComponent } from './jobs/components/job-order-details/job-order-details.component';
import { JobNavigationService } from './jobs/resources/job-navigation.service';
import { JobFinancialsListComponent } from './jobs/components/job-financials-list/job-financials-list.component';
import { JobFinancialsListBusinessService } from './jobs/resources/job-financials-list-business.service';
import { JobSpecListComponent } from './jobs/components/job-spec-list/job-spec-list.component';
import { JobSpecListBusinessService } from './jobs/resources/job-spec-list-business.service';
import {
  JobColorSelectionListComponent,
} from './jobs/components/job-color-selection-list/job-color-selection-list.component';
import { JobCsListBusinessService } from './jobs/resources/job-cs-list-business.service';
import {
  JobDppDetailsLetterListTabComponent,
} from './jobs/components/job-dpp-details-container/job-dpp-details-letter-list-tab/job-dpp-details-letter-list-tab.component';
import {
  JobDppDetailsCommunicationListTabComponent,
} from './jobs/components/job-dpp-details-container/job-dpp-details-communication-list-tab/job-dpp-details-communication-list-tab.component';
import {
  JobDetailsChecklistsTabComponent,
} from './jobs/components/job-details-tab-container/job-details-checklists-tab/job-details-checklists-tab.component';
import {
  JobDppDetailsChecklistsTabComponent,
} from './jobs/components/job-dpp-details-container/job-dpp-details-checklists-tab/job-dpp-details-checklists-tab.component';

@NgModule({
  imports: [
    CoreUiExtSplitPaneModule,
    CoreUiExtTreeModule,
    BuilderSharedModule.forChild(),

    BuilderJobAdminRoutingModule,
  ],
  providers: [
    JobListBusinessService,
    JobQuickDetailsBusinessService,
    JobSpecBusinessService,
    JobDPPBusinessService,
    JobCsDetailsBusinessService,
    JobCoListBusinessService,
    JobCoJobListBusinessService,
    JobCoDetailsBusinessService,
    JobDetailsTabBusinessService,
    JobDrawDetailsTabBusinessService,
    JobEstimateDetailsBusinessService,
    JobOrderListBusinessService,
    JobOrderDetailsListBusinessService,
    JobOrderDetailsBusinessService,
    JobFinancialsBusinessService,
    JobNavigationService,
    JobFinancialsListBusinessService,
    JobSpecListBusinessService,
    JobCsListBusinessService,
  ],
  declarations: [
    JobListComponent,
    JobQuickDetailsComponent,
    JobSpecDetailsComponent,
    JobSpecTopFormComponent,
    JobSpecParagraphFormComponent,
    JobSpecSectionFormComponent,
    JobSpecQuoteChangesFormComponent,
    JobDppDetailsContainerComponent,
    JobDppDetailsLetterListTabComponent,
    JobDppDetailsChecklistsTabComponent,
    JobDppDetailsGeneralTabComponent,
    JobDppDetailsCommunicationListTabComponent,
    JobCsDetailsComponent,
    JobCsDetailsHeadingListComponent,
    JobCsDetailsSubheadingListComponent,
    JobCsDetailsItemListComponent,
    JobCsDetailsQcListComponent,
    JobCsDetailsCcListComponent,
    JobCsDetailsTopFormComponent,
    JobCoListComponent,
    JobCoJobListComponent,
    JobCoTopFormComponent,
    JobCoDetailsComponent,
    JobCoDetailsTopFormComponent,
    JobCoDetailsElementListComponent,
    JobCoDetailsBottomPanelComponent,
    JobCoDetailsQuoteFilterDialogComponent,
    JobDetailsTabContainerComponent,
    JobDetailsWarrantyTabComponent,
    JobDetailToolbarComponent,
    JobDetailsWarrantyTaskDialogComponent,
    JobDetailsGeneralTabComponent,
    JobEstimateDetailsComponent,
    JeDetailsCcListComponent,
    JeDetailsTopListComponent,
    JeDetailsComponentsParentComponent,
    JeDetailsComponentListComponent,
    JeDetailsComponentDetailsComponent,
    JeDetailsCuttingListComponent,
    JeDetailsCcParentComponent,
    JeDetailsCcItemListComponent,
    JeDetailsCcItemDetailsComponent,
    JeDetailsCcItemComponentComponent,
    JeDetailsOrderListComponent,
    JeDetailsColorSelectionListComponent,
    JeCcOrderDetailsDialogComponent,
    JeTopUsageDialogComponent,
    JeAddOrdersDialogComponent,
    JobDetailsDatesTabComponent,
    SelectSupervisorDialogComponent,
    JobDetailsRfqTabComponent,
    JobDetailsLetterListTabComponent,
    JobDetailsChecklistsTabComponent,
    JobDetailsEDocsTabComponent,
    JobDetailsEDocsOwnerSetFormComponent,
    JobDetailsEDocsManagementComponent,
    JobDetailsVariationListTabComponent,
    JobDetailsInsuranceTabComponent,
    JobDetailsCommunicationListTabComponent,
    JobOrderListComponent,
    JobOrderDetailsComponent,
    JobOrderDetailsTopFormComponent,
    JobOrderDetailsBodyComponent,
    JobOrderDetailsBottomPanelComponent,
    JobOrderDetailsAttachmentDialogComponent,
    JobOrderDetailsDialogComponent,
    JobDetailsSharedDocListTabComponent,
    JobFinancialsListComponent,
    JobFinancialsComponent,
    JobFinancialsDrawListComponent,
    JobFinancialsExpenseListComponent,
    JobFinancialsTopFormComponent,
    JobFinancialsTradingAccountComponent,
    JobDetailsReassignDialogComponent,
    JobSpecListComponent,
    JobColorSelectionListComponent,
  ],
  entryComponents: [
    JobDppDetailsGeneralTabComponent,
    JobDetailsWarrantyTabComponent,
    JobDetailsWarrantyTaskDialogComponent,
    JobDetailsRfqTabComponent,
    JeCcOrderDetailsDialogComponent,
    JeTopUsageDialogComponent,
    JeAddOrdersDialogComponent,
    JobDetailsDatesTabComponent,
    SelectSupervisorDialogComponent,
    JobDetailsLetterListTabComponent,
    JobDetailsChecklistsTabComponent,
    JobDetailsVariationListTabComponent,
    JobDetailsInsuranceTabComponent,
    JobDetailsCommunicationListTabComponent,
    JobOrderDetailsAttachmentDialogComponent,
    JobOrderDetailsDialogComponent,
    JobCoDetailsQuoteFilterDialogComponent,
    JobFinancialsExpenseListComponent,
    JobFinancialsTradingAccountComponent,
    JobDetailsReassignDialogComponent,
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
})

export class BuilderJobAdminModule {
}
